import { HardwareStatus } from '../../domainServices/HardwareService';
import { fetchWrapper } from '../fetchWrapper';

export async function assignHardwareToOffice(
  id: string,
  hardwareIds: Record<number, HardwareStatus>,
) {
  return fetchWrapper({
    url: `api/office/${id}/hardware/assignment`,
    fetchArg: {
      method: 'PUT',
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json-patch+json',
      },
      body: { hardwareIds },
    },
  });
}
